import { createStyles } from '@mantine/core'
export default createStyles(() => {
  return {
    root: {
      overflow: 'hidden',
      img: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
      },
    },
    wrapper: {
      position: 'relative',
    },
  }
})
